import { render } from "./QuoteTabs.vue?vue&type=template&id=b5d30352"
import script from "./QuoteTabs.vue?vue&type=script&lang=js"
export * from "./QuoteTabs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__